import { debounce} from "./utilities";


function resizeAnimationStopperJS() {
    const resizeAnimationStopperClass = 'windowIsResizing';

    const removeResizeClass = () =>  {
        document.body.classList.remove(resizeAnimationStopperClass);
    }

    const debouncedRemoveResizeClass = debounce(removeResizeClass, 400);

    const addResizeClass = () => {
        document.body.classList.add(resizeAnimationStopperClass);
        debouncedRemoveResizeClass();
    }

    window.addEventListener('resize', addResizeClass);

    // Add functio for preload (.preload)

}

resizeAnimationStopperJS();

export { resizeAnimationStopperJS };
